import React from "react"
import { Dialog, FlatButton, TextField, Card, CardHeader, CardText, Chip, RaisedButton, CircularProgress} from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { IMessageGroupMemberSummary, IMessageGroupSend, ISuggestedMessagePrompt } from "../../models/documents/MessageGroupDocument"
import * as api from "../../api"

interface IProps {
    messageGroupName: string,
    contextDescription: string,
    objectId: string,
    newMessageOpen: boolean,
    send(IMessageGroupSend): void,
    cancel(): void,
    members: IMessageGroupMemberSummary[]
}

interface IState{
    smsText: string
    memberExpanded: boolean
    loading: boolean
    promptText: string
}

export default class MessageCenterNewMessageDialog extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            smsText: "",
            promptText: "",
            memberExpanded: false,
            loading: false
        }
        autobind(this)
    }

    componentDidMount(): void {
        //this.getPrompt()
    }

    getPrompt(){
        this.setState({loading: true}, ()=> {
            api.getSuggestedMessage({Prompt: this.state.promptText} as ISuggestedMessagePrompt).then((res) => {
                this.setState({smsText: res.data, loading: false})					
            })    
        })
    }

	expandMembers(){
		this.setState({memberExpanded: !this.state.memberExpanded})		
	}

	render() {
        return (
        <Dialog
            actions={[
                <FlatButton
                    data-intercom-target={"IP-Btn-CloseAddIPDialog"}
                    label={strings.CANCEL}
                    secondary
                    onClick={() => {
                        this.props.cancel()
                    }}
                />,
                <FlatButton
                    data-intercom-target={"Btn-UpgradeFreeAccountDataLimitUpgradeDialog"}
                    label={strings.SendMessage}
                    primary
                    keyboardFocused
                    onClick={() => {
                        this.props.send({
                            Name: this.props.messageGroupName,
                            ContextDescription: this.props.contextDescription,
                            ObjectIds: [this.props.objectId],
                            UserIds: this.props.members.map((member, index)=> member.UserId),
                            TemplateText: this.state.smsText
                        } as IMessageGroupSend)
                    }}
                />
            ]}
            modal
            open={this.props.newMessageOpen}
        >
            <div style={{marginBottom: 15}}>Compose New Text Message</div>
            {this.props.members && 
                <Card data-intercom-target={`menu-message-center-members-Tab`} expanded={this.state.memberExpanded} onExpandChange={this.expandMembers}>
                    <CardHeader title={this.props.members.length  + " " + strings.Gig_Pool_Members} showExpandableButton={true} actAsExpander={true} />
                    <CardText expandable>
                        <div style={{display: "flex", flexWrap: "wrap" }}>
                            {this.props.members.map((item, index)=> 
                                <Chip key={index} style={{ margin: 5 }} onRequestDelete={{}}>
                                    {item.Name}
                                </Chip>							
                            )}	
                        </div>
                    </CardText>
                </Card>
            }


            <TextField
                style={{ width: "80%" }}
                floatingLabelText={"AI Prompt Text"}
                value={this.state.promptText}
                multiLine
                fullWidth
                rows={2}
                rowsMax={4}
                onChange={e => this.setState({ promptText: e.target.value })}
            />

            <RaisedButton
                icon={<i className="fa-solid fa-message-bot" style={{color: "white"}} />}
                data-intercom-target={"IP-Btn-compose-message"}
                label={"Generate AI Text"}
                secondary
                onClick={this.getPrompt}            
            />  

            {this.state.loading && 
                <div>
                    <div className="spinner"><CircularProgress /></div>
                </div>
            }

            {!this.state.loading && 
                <TextField
                    style={{ width: "80%" }}
                    floatingLabelText={strings.Message}
                    value={this.state.smsText}
                    multiLine
                    fullWidth
                    rows={4}
                    rowsMax={6}
                    onChange={e => this.setState({ smsText: e.target.value })}
                />
            }

          
        </Dialog>	
    )}
}